import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EmptyStatePanel } from '@/components/common/EmptyStatePanel';

export const AIEngineeringAnalysisPanel = ({ task }) => {
  const analysis = task?.analysis_result;

  if (!analysis) {
    return <EmptyStatePanel title="Analyze Real ainda não executado" description="Corra o Analyze para ver resumo técnico, causa provável, impacto, ficheiros afectados, risco, próximos passos e limites da análise." ctaLabel={null} testId="ai-engineering-empty-analysis" />;
  }

  return (
    <Card className="border-slate-200 shadow-sm" data-testid="ai-engineering-analysis-panel">
      <CardHeader className="pb-3">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <CardTitle className="text-base font-semibold text-slate-900">Analyze Real</CardTitle>
          <div className="flex flex-wrap gap-2">
            <Badge variant="outline" className="rounded-sm border-blue-200 bg-blue-50 text-blue-700" data-testid="ai-engineering-analysis-risk-badge">Risco observado: {analysis?.risk_assessment?.observed_risk || 'n/d'}</Badge>
            <Badge variant="outline" className="rounded-sm border-slate-300 bg-white text-slate-700" data-testid="ai-engineering-analysis-confidence-badge">Confiança: {analysis?.confidence?.label || 'n/d'} ({analysis?.confidence?.score || 0})</Badge>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4 text-sm">
        <div className="grid gap-3 md:grid-cols-2">
          <div className="rounded-sm border border-slate-200 bg-slate-50 p-3" data-testid="ai-engineering-analysis-summary-box">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Resumo técnico</p>
            <p className="mt-2 text-slate-900">{analysis.technical_summary}</p>
          </div>
          <div className="rounded-sm border border-slate-200 bg-slate-50 p-3" data-testid="ai-engineering-analysis-cause-box">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Causa provável</p>
            <p className="mt-2 text-slate-900">{analysis.probable_cause}</p>
          </div>
        </div>

        <div className="rounded-sm border border-slate-200 bg-slate-50 p-3" data-testid="ai-engineering-analysis-impact-box">
          <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Impacto provável</p>
          <p className="mt-2 text-slate-900">{analysis.probable_impact}</p>
        </div>

        <div className="grid gap-3 md:grid-cols-2">
          <div className="rounded-sm border border-slate-200 p-3" data-testid="ai-engineering-analysis-files-box">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Ficheiros potencialmente afectados</p>
            <div className="mt-3 space-y-2">
              {(analysis.potentially_affected_files || []).map((item) => (
                <div key={`${task.id}-${item.path}`} className="rounded-sm border border-slate-200 bg-slate-50 p-2">
                  <p className="font-medium text-slate-900">{item.path}</p>
                  <p className="text-xs text-slate-500">{item.reason}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-sm border border-slate-200 p-3" data-testid="ai-engineering-analysis-next-steps-box">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Próximos passos recomendados</p>
            <ul className="mt-3 list-disc space-y-2 pl-5 text-slate-900">
              {(analysis.recommended_next_steps || []).map((step) => (<li key={step}>{step}</li>))}
            </ul>
          </div>
        </div>

        <div className="grid gap-3 md:grid-cols-2">
          <div className="rounded-sm border border-slate-200 p-3" data-testid="ai-engineering-analysis-limits-box">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Limites da análise</p>
            <ul className="mt-3 list-disc space-y-2 pl-5 text-slate-900">
              {(analysis.analysis_limits || []).map((item) => (<li key={item}>{item}</li>))}
            </ul>
          </div>

          <div className="rounded-sm border border-slate-200 p-3" data-testid="ai-engineering-analysis-manifest-box">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Manifesto de contexto</p>
            <p className="mt-2 text-xs text-slate-600">Modo: {analysis?.context_manifest?.mode || 'n/d'} • leitura aberta: {String(analysis?.context_manifest?.open_repository_read)}</p>
            <div className="mt-3 space-y-2">
              {(analysis?.context_manifest?.included_files || []).map((item) => (
                <div key={`${task.id}-manifest-${item.path}`} className="rounded-sm border border-slate-200 bg-slate-50 p-2">
                  <p className="font-medium text-slate-900">{item.path}</p>
                  <p className="text-xs text-slate-500">{item.role} • {item.why}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};